import { createContext, useContext } from "react";

/** Interface */
interface IPopoverContext {
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
	handleOnClose: () => void;
}

/** Context */
export const PopoverContext = createContext<IPopoverContext>({
	isOpen: false,
	setIsOpen: () => {},
	handleOnClose: () => {},
});

/** Hook */
export function usePopoverContext() {
	return useContext(PopoverContext);
}
